<template>
    <project-step-container
            prev-to="be_go_broad_to_go_narrow_14"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
            :next-disabled="Object.keys(form.idea).length === 0"
    >
        <b-row class="first-form">
            <b-col cols="12" class="simple-text" tabindex="0">
              {{getMessage(15, 'gobroadtogonarrow-sub')}}
            </b-col>
        </b-row>
        <b-row class="mt-3 text-center">
           <b-col cols="12"  class="button-next" :key="index" v-for="(idea, index) in topIdeasList">
                <b-button   value="0" name="white"
                    variant="secondary"  class="square" block size="lg" v-bind:class="{ active: form.idea.key  === idea.key, isCareerEntrep: isJACareerEntrepreApp}" v-on:click="select(idea.key)">
                    <span >{{idea.value}}</span>
                </b-button>
            </b-col>
        </b-row>

    </project-step-container>
</template>

<script>
    import {Storage, Project, ConflictSyn} from "../../../core/Utils"
    import Steps from "../Utils/steps";
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"

    const IdeasList = Object.freeze({
        FIRSTIDEALIST: 0,
        SECONDIDEALIST: 1,
        THIRDIDEALIST: 2,
    })

    export default {
        name: "GoBroadToGoNarrow15",
        components: {ProjectStepContainer},
        props: ['items'],
        data() {
            return {
                step: Steps.FORM_IDEAS_LIST,
                urlNextProject:'be_go_broad_to_go_narrow_16',
                form: {
                    idea: {},
                },
                topIdeasList: [],
                index : '',
                ideasList: IdeasList
            }
        },
        created() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
            this.topIdeasList =  Object.values(forms[Steps.FORM_TOP_IDEAS]).map((item , index) => ({"key": index, "value": item}));
        },
        methods: {
            select(num) {
                const form = this.form
                form.idea = this.topIdeasList.filter((idea, i) => idea.key == num)[0];
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        } ,
    }
</script>

